(function attachSocialPlatformCatalog(root, factory) {
  const catalog = factory();

  if (typeof module === "object" && module.exports) {
    module.exports = catalog;
  }

  if (root) {
    root.EpicSocialPlatformCatalog = catalog;
  }
})(typeof window !== "undefined" ? window : globalThis, function createSocialPlatformCatalog() {
  function deepFreeze(value) {
    if (!value || typeof value !== "object" || Object.isFrozen(value)) return value;
    Object.values(value).forEach(deepFreeze);
    return Object.freeze(value);
  }

  function platform(definition) {
    return {
      reservedPaths: [],
      acceptedHostPatterns: [],
      handlePattern: null,
      handleStripPattern: "^@",
      handleUrlTemplate: null,
      supportsHandle: false,
      ...definition,
      iconAsset: `/shared/socials/icons/${definition.icon || definition.key}.svg`
    };
  }

  const platforms = deepFreeze([
    platform({
      key: "instagram", displayName: "Instagram", category: "social", searchAliases: ["ig", "insta"],
      acceptedHosts: ["instagram.com", "www.instagram.com"], profilePathPatterns: ["^/[A-Za-z0-9._]+/?$"],
      reservedPaths: ["accounts", "direct", "explore", "reel", "reels", "stories"], supportsHandle: true,
      handlePattern: "^@?[A-Za-z0-9._]{1,30}$", handleUrlTemplate: "https://www.instagram.com/{handle}/"
    }),
    platform({
      key: "tiktok", displayName: "TikTok", category: "social", searchAliases: ["tik tok"],
      acceptedHosts: ["tiktok.com", "www.tiktok.com", "m.tiktok.com"], profilePathPatterns: ["^/@[A-Za-z0-9._-]+/?$"],
      supportsHandle: true, handlePattern: "^@?[A-Za-z0-9._-]{2,30}$", handleUrlTemplate: "https://www.tiktok.com/@{handle}"
    }),
    platform({
      key: "facebook", displayName: "Facebook", category: "social", searchAliases: ["fb", "meta"],
      acceptedHosts: ["facebook.com", "www.facebook.com", "m.facebook.com"],
      profilePathPatterns: ["^/[A-Za-z0-9._-]+/?$", "^/profile\\.php$"], reservedPaths: ["groups", "marketplace", "messages", "reel", "share", "watch"],
      supportsHandle: true, handlePattern: "^@?[A-Za-z0-9._-]{3,80}$", handleUrlTemplate: "https://www.facebook.com/{handle}"
    }),
    platform({
      key: "x", displayName: "X", category: "social", searchAliases: ["twitter", "x twitter"],
      acceptedHosts: ["x.com", "www.x.com", "twitter.com", "www.twitter.com"], profilePathPatterns: ["^/[A-Za-z0-9_]+/?$"],
      reservedPaths: ["compose", "explore", "home", "i", "messages", "search", "settings"], supportsHandle: true,
      handlePattern: "^@?[A-Za-z0-9_]{1,15}$", handleUrlTemplate: "https://x.com/{handle}"
    }),
    platform({
      key: "threads", displayName: "Threads", category: "social", searchAliases: ["threads.net", "meta threads"],
      acceptedHosts: ["threads.net", "www.threads.net"], profilePathPatterns: ["^/@[A-Za-z0-9._]+/?$"],
      supportsHandle: true, handlePattern: "^@?[A-Za-z0-9._]{1,30}$", handleUrlTemplate: "https://www.threads.net/@{handle}"
    }),
    platform({
      key: "snapchat", displayName: "Snapchat", category: "social", searchAliases: ["snap"],
      acceptedHosts: ["snapchat.com", "www.snapchat.com"], profilePathPatterns: ["^/(add|t)/[A-Za-z0-9._-]+/?$"],
      supportsHandle: true, handlePattern: "^@?[A-Za-z0-9._-]{3,30}$", handleUrlTemplate: "https://www.snapchat.com/add/{handle}"
    }),
    platform({
      key: "bluesky", displayName: "Bluesky", category: "social", searchAliases: ["bsky", "blue sky"],
      acceptedHosts: ["bsky.app", "www.bsky.app"], profilePathPatterns: ["^/profile/[A-Za-z0-9._:-]+/?$"],
      supportsHandle: true, handlePattern: "^@?[A-Za-z0-9.-]{3,253}$", handleUrlTemplate: "https://bsky.app/profile/{handle}"
    }),
    platform({
      key: "mastodon", displayName: "Mastodon", category: "social", searchAliases: ["fediverse"],
      acceptedHosts: ["*"], profilePathPatterns: ["^/@[A-Za-z0-9_.-]+/?$"], supportsHandle: false
    }),
    platform({
      key: "pinterest", displayName: "Pinterest", category: "social", searchAliases: ["pin"],
      acceptedHosts: ["pinterest.com", "www.pinterest.com"], profilePathPatterns: ["^/[A-Za-z0-9_-]+/?$"],
      reservedPaths: ["ideas", "pin", "search", "today"], supportsHandle: true,
      handlePattern: "^@?[A-Za-z0-9_-]{3,30}$", handleUrlTemplate: "https://www.pinterest.com/{handle}/"
    }),
    platform({
      key: "youtube", displayName: "YouTube", category: "community-entertainment", searchAliases: ["yt", "youtube channel"],
      acceptedHosts: ["youtube.com", "www.youtube.com", "m.youtube.com"],
      profilePathPatterns: ["^/@[A-Za-z0-9._-]+/?$", "^/(channel|c|user)/[A-Za-z0-9._-]+/?$"],
      reservedPaths: ["feed", "playlist", "results", "shorts", "watch"], supportsHandle: true,
      handlePattern: "^@?[A-Za-z0-9._-]{3,30}$", handleUrlTemplate: "https://www.youtube.com/@{handle}"
    }),
    platform({
      key: "twitch", displayName: "Twitch", category: "community-entertainment", searchAliases: ["twitch tv"],
      acceptedHosts: ["twitch.tv", "www.twitch.tv"], profilePathPatterns: ["^/[A-Za-z0-9_]+/?$"],
      reservedPaths: ["directory", "downloads", "jobs", "p", "settings", "videos"], supportsHandle: true,
      handlePattern: "^@?[A-Za-z0-9_]{3,25}$", handleUrlTemplate: "https://www.twitch.tv/{handle}"
    }),
    platform({
      key: "kick", displayName: "Kick", category: "community-entertainment", searchAliases: ["kick streaming"],
      acceptedHosts: ["kick.com", "www.kick.com"], profilePathPatterns: ["^/[A-Za-z0-9_-]+/?$"],
      reservedPaths: ["browse", "categories", "following", "search"], supportsHandle: true,
      handlePattern: "^@?[A-Za-z0-9_-]{3,30}$", handleUrlTemplate: "https://kick.com/{handle}"
    }),
    platform({
      key: "discord", displayName: "Discord", category: "community-entertainment", searchAliases: ["discord invite", "discord server"],
      acceptedHosts: ["discord.gg", "discord.com", "www.discord.com"],
      profilePathPatterns: ["^/[A-Za-z0-9_-]+/?$", "^/(invite|users)/[A-Za-z0-9_-]+/?$"], supportsHandle: false
    }),
    platform({
      key: "reddit", displayName: "Reddit", category: "community-entertainment", searchAliases: ["subreddit", "redditor"],
      acceptedHosts: ["reddit.com", "www.reddit.com", "old.reddit.com"], profilePathPatterns: ["^/(u|user)/[A-Za-z0-9_-]+/?$"],
      supportsHandle: true, handlePattern: "^@?[A-Za-z0-9_-]{3,20}$", handleUrlTemplate: "https://www.reddit.com/user/{handle}/"
    }),
    platform({
      key: "linkedin", displayName: "LinkedIn", category: "business-development", searchAliases: ["linked in", "linkedin company"],
      acceptedHosts: ["linkedin.com", "www.linkedin.com"], profilePathPatterns: ["^/(in|company)/[A-Za-z0-9_%.-]+/?$"],
      supportsHandle: true, handlePattern: "^@?[A-Za-z0-9-]{3,100}$", handleUrlTemplate: "https://www.linkedin.com/in/{handle}/"
    }),
    platform({
      key: "github", displayName: "GitHub", category: "business-development", searchAliases: ["git hub", "developer profile"],
      acceptedHosts: ["github.com", "www.github.com"], profilePathPatterns: ["^/[A-Za-z0-9-]+/?$"],
      reservedPaths: ["about", "collections", "events", "explore", "features", "marketplace", "notifications", "orgs", "settings", "sponsors", "topics"],
      supportsHandle: true, handlePattern: "^@?[A-Za-z0-9-]{1,39}$", handleUrlTemplate: "https://github.com/{handle}"
    }),
    platform({
      key: "spotify", displayName: "Spotify", category: "music", searchAliases: ["spotify artist", "spotify show"],
      acceptedHosts: ["open.spotify.com"], profilePathPatterns: ["^/(artist|user|show)/[A-Za-z0-9]+/?$"], supportsHandle: false
    }),
    platform({
      key: "apple-music", displayName: "Apple Music", category: "music", icon: "apple-music", searchAliases: ["itunes", "apple artist"],
      acceptedHosts: ["music.apple.com"], profilePathPatterns: ["^/[a-z]{2}/(artist|album|playlist|station)/.+$"], supportsHandle: false
    }),
    platform({
      key: "soundcloud", displayName: "SoundCloud", category: "music", searchAliases: ["sound cloud"],
      acceptedHosts: ["soundcloud.com", "www.soundcloud.com"], profilePathPatterns: ["^/[A-Za-z0-9_-]+/?$"],
      reservedPaths: ["charts", "discover", "search", "stream", "you"], supportsHandle: true,
      handlePattern: "^@?[A-Za-z0-9_-]{3,50}$", handleUrlTemplate: "https://soundcloud.com/{handle}"
    }),
    platform({
      key: "bandcamp", displayName: "Bandcamp", category: "music", searchAliases: ["band camp"], acceptedHosts: [],
      acceptedHostPatterns: ["^[A-Za-z0-9-]+\\.bandcamp\\.com$"], profilePathPatterns: ["^/?$"], supportsHandle: true,
      handlePattern: "^@?[A-Za-z0-9-]{1,63}$", handleUrlTemplate: "https://{handle}.bandcamp.com/"
    }),
    platform({
      key: "patreon", displayName: "Patreon", category: "support-payments", searchAliases: ["support creator"],
      acceptedHosts: ["patreon.com", "www.patreon.com"], profilePathPatterns: ["^/[A-Za-z0-9_-]+/?$", "^/c/[A-Za-z0-9_-]+/?$"],
      supportsHandle: true, handlePattern: "^@?[A-Za-z0-9_-]{2,80}$", handleUrlTemplate: "https://www.patreon.com/{handle}"
    }),
    platform({
      key: "ko-fi", displayName: "Ko-fi", category: "support-payments", icon: "ko-fi", searchAliases: ["kofi", "ko fi"],
      acceptedHosts: ["ko-fi.com", "www.ko-fi.com"], profilePathPatterns: ["^/[A-Za-z0-9_-]+/?$"], supportsHandle: true,
      handlePattern: "^@?[A-Za-z0-9_-]{2,80}$", handleUrlTemplate: "https://ko-fi.com/{handle}"
    }),
    platform({
      key: "buy-me-a-coffee", displayName: "Buy Me a Coffee", category: "support-payments", icon: "buy-me-a-coffee",
      searchAliases: ["buymeacoffee", "coffee", "bmac"], acceptedHosts: ["buymeacoffee.com", "www.buymeacoffee.com"],
      profilePathPatterns: ["^/[A-Za-z0-9_-]+/?$"], supportsHandle: true,
      handlePattern: "^@?[A-Za-z0-9_-]{2,80}$", handleUrlTemplate: "https://buymeacoffee.com/{handle}"
    }),
    platform({
      key: "paypal", displayName: "PayPal", category: "support-payments", searchAliases: ["paypal me"],
      acceptedHosts: ["paypal.me", "www.paypal.me"], profilePathPatterns: ["^/[A-Za-z0-9._-]+/?$"], supportsHandle: true,
      handlePattern: "^@?[A-Za-z0-9._-]{2,80}$", handleUrlTemplate: "https://paypal.me/{handle}"
    }),
    platform({
      key: "venmo", displayName: "Venmo", category: "support-payments", searchAliases: ["venmo profile"],
      acceptedHosts: ["venmo.com", "www.venmo.com", "account.venmo.com"], profilePathPatterns: ["^/u/[A-Za-z0-9_-]+/?$"], supportsHandle: true,
      handlePattern: "^@?[A-Za-z0-9_-]{2,30}$", handleUrlTemplate: "https://venmo.com/u/{handle}"
    }),
    platform({
      key: "cash-app", displayName: "Cash App", category: "support-payments", icon: "cash-app", searchAliases: ["cashapp", "cashtag"],
      acceptedHosts: ["cash.app"], profilePathPatterns: ["^/\\$[A-Za-z0-9_-]+/?$"], supportsHandle: true,
      handlePattern: "^[@$]?[A-Za-z0-9_-]{1,20}$", handleStripPattern: "^[@$]", handleUrlTemplate: "https://cash.app/${handle}"
    }),
    platform({
      key: "custom", displayName: "Website", category: "other", icon: "link", searchAliases: ["custom", "link", "profile", "website"],
      acceptedHosts: ["*"], profilePathPatterns: ["^/.*$"], supportsHandle: false
    })
  ]);

  const platformByKey = new Map(platforms.map((item) => [item.key, item]));
  const platformByAlias = new Map();
  platforms.forEach((item) => {
    [item.key, item.displayName, ...item.searchAliases].forEach((value) => {
      platformByAlias.set(String(value).trim().toLowerCase(), item);
    });
  });

  function getPlatform(value) {
    const normalized = String(value || "").trim().toLowerCase();
    return platformByKey.get(normalized) || platformByAlias.get(normalized) || null;
  }

  function resolvePlatform(value) {
    return getPlatform(value) || platformByKey.get("custom");
  }

  function searchPlatforms(queryValue = "", categoryValue = "") {
    const query = String(queryValue || "").trim().toLowerCase();
    const category = String(categoryValue || "").trim().toLowerCase();
    return platforms.filter((item) => {
      if (category && item.category !== category) return false;
      if (!query) return true;
      return [item.key, item.displayName, ...item.searchAliases]
        .some((value) => String(value).toLowerCase().includes(query));
    });
  }

  function parseWebUrl(value) {
    try {
      const parsed = new URL(String(value || "").trim());
      if (!["http:", "https:"].includes(parsed.protocol)) return null;
      if (parsed.username || parsed.password || !parsed.hostname) return null;
      return parsed;
    } catch {
      return null;
    }
  }

  function hostMatches(item, hostname) {
    if (item.acceptedHosts.includes("*")) return true;
    if (item.acceptedHosts.includes(hostname)) return true;
    return item.acceptedHostPatterns.some((pattern) => new RegExp(pattern, "i").test(hostname));
  }

  function acceptsProfileUrl(platformValue, urlValue) {
    const item = getPlatform(platformValue);
    const parsed = parseWebUrl(urlValue);
    if (!item || !parsed || !hostMatches(item, parsed.hostname.toLowerCase())) return false;

    const firstPathPart = parsed.pathname.split("/").filter(Boolean)[0]?.toLowerCase() || "";
    if (item.reservedPaths.includes(firstPathPart)) return false;

    return item.profilePathPatterns.some((pattern) => new RegExp(pattern).test(parsed.pathname));
  }

  function profileUrlFromHandle(platformValue, handleValue) {
    const item = getPlatform(platformValue);
    if (!item?.supportsHandle || !item.handlePattern || !item.handleUrlTemplate) return null;

    const original = String(handleValue || "").trim();
    if (!new RegExp(item.handlePattern).test(original)) return null;
    const handle = original.replace(new RegExp(item.handleStripPattern || "^@"), "");
    return item.handleUrlTemplate.replace("{handle}", encodeURIComponent(handle));
  }

  return deepFreeze({
    platforms,
    getPlatform,
    resolvePlatform,
    searchPlatforms,
    parseWebUrl,
    acceptsProfileUrl,
    profileUrlFromHandle
  });
});
